<template>
    <div class="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <ContactUs />
                </div>
                <div class="col-lg-6">
                    <ContactInformations />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContactInformations from '@/components/Contact/ContactInformations'
import ContactUs from '@/components/Contact/ContactUs'

export default {
    components: {
        ContactInformations,
        ContactUs
    },
    name: "ContactPage"
}
</script>

<style lang="scss" scoped>
    @import "@/scss/helpers/mixins";
    @import "@/scss/helpers/variables";

    .contact {
        background-color: #F5F5F5;
        width: 100%;
        padding: 45px 0 35px;

        @include min($lg) {
            padding: 83px 0 75px; 
        }
    }
</style>